(function () {
  if (!document.body.classList.contains('template-product')) return;

  var REVIEW_SELECTORS = [
    '.loox-review-item',
    '.loox-review',
    '[data-loox-review-id]',
    '.loox-reviews-redesigned-review',
    '.loox-review-list-item'
  ];

  function findLooxRoot() {
    return document.getElementById('looxReviews');
  }

  function findSection(looxRoot) {
    return looxRoot.closest('.shopify-section');
  }

  function hasReviews(looxRoot) {
    for (var i = 0; i < REVIEW_SELECTORS.length; i++) {
      if (looxRoot.querySelector(REVIEW_SELECTORS[i])) return true;
    }
    return false;
  }

  function init() {
    var looxRoot = findLooxRoot();
    if (!looxRoot) {
      // Loox script may inject #looxReviews after page load — watch the body.
      var bodyObserver = new MutationObserver(function () {
        if (findLooxRoot()) {
          bodyObserver.disconnect();
          init();
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { bodyObserver.disconnect(); }, 30000);
      return;
    }

    var section = findSection(looxRoot);
    if (!section) return;

    function reveal() {
      if (hasReviews(looxRoot)) {
        section.classList.add('pdp-loox-has-reviews');
        document.body.classList.add('pdp-loox-has-reviews');
        return true;
      }
      return false;
    }

    if (reveal()) return;

    var observer = new MutationObserver(function () {
      if (reveal()) observer.disconnect();
    });
    observer.observe(looxRoot, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
